export const SMARTLOOK_SAFE_ROUTES = [
    '/app/home'
];